import React from 'react'
import newSubtestReport from '../../../helpers/assessment/newSubtestReport';
import ScoreChart from './ScoreChart'
import AreasToImprove from './AreasToImprove'
import BreakdownSkillBar from './BreakdownSkillBar'
import values from 'mout/object/values'
import PassageBreakdowns from './PassageBreakdowns'
import getByPassageType from '../../../helpers/assessment/getByPassageType';

const uuid = require('uuid/v1')

export default function SkillBreakdownReport ({scores, subtest, nodes, maxNodeLevel, headerText, isGroup}) {
  const subtestId = subtest.setId
  const name = subtest.displayName
  const report = newSubtestReport(scores, subtest, nodes, maxNodeLevel).report
  const bySubtest = scores.bySubtest[subtestId]
  const byNode = scores.byNode[subtestId]
  let maxBars = 13
  if (name === 'Reading' || name === 'Science') {
    maxBars = 9
  }
  let byPassageType = null
  if (name === 'Reading' || name === 'Science') {
    byPassageType = getByPassageType(subtest, scores)
  }

  const vert = name === 'English' ? 'vertical-content ' : ''
  let classString = `new-page ${vert}subject-report ${name.toLowerCase()}`

  function sortReport(report) {
    const subReports = values(report)
    return subReports.sort((a, b) => {
      if (!a[0] && !b[0]) {
        return 0
      } else if (!a[0]) {
        return -1
      } else if (!b[0]) {
        return 1
      } else if (a[0].name > b[0].name) {
        return 1
      } else if (a[0].name < b[0].name) {
        return -1
      } else {
        return 0
      }
    })
  }
  const sortedReport = sortReport(report)
  
  let col = {
    one: [],
    two: [],
    three: [],
  }
  const colIndex = ['one', 'two', 'three']
  let activeCol = 0
  let colBarCount = 0


  sortedReport.forEach((category) => {
    if (category.length > 0) {
      let catBars = []
      let barCount = 0
      for (let i = 0; i < category.length; i++) {
        const skill = category[i]
        let nextSkillLev3 = false
        if (category[i + 1]) {
          if (category[i + 1].level == 3) {
            nextSkillLev3 = true
          }
        }
        if (skill.level == 1 || (skill.level == 2 && !nextSkillLev3)) {
          catBars.push(
            <BreakdownSkillBar
              nodeLevel={skill.level}
              name={skill.name}
              percent={Math.round(100 * skill.percent)}
              key={skill.id}
            />
          )
          barCount++
        } else if (skill.level == 2) {
          let treeBars = []
          const topSkill = Object.assign({}, skill)
          barCount++
          for (let n = 1; n < category.length - i; n++) {
            let subSkill = category[i + n]
            if (subSkill.level == 3) {
              treeBars.push(
                <BreakdownSkillBar
                  nodeLevel={subSkill.level}
                  name={subSkill.name}
                  percent={Math.round(100 * subSkill.percent)}
                  key={subSkill.id}
                />
              )
              barCount++
              if (n === category.length - i - 1) {
                i += n
                break
              }
            } else {
              // i += n
              break
            }
          }
          const topPerc = Math.round(100 * topSkill.percent)
          catBars.push(
            <div className='skill-item sub-skill' key={topSkill.id}>
              <h6 className='title'>{topSkill.name}</h6>
              <div className='bar-graph'>
                <span className='score-percent'>{`${topPerc}%`}</span>
                <div className='score-graph-container'>
                  <span className='score-graph' style={{width: `${topPerc}%`}}></span>
                </div>
              </div>
              <ul className="sub-of-sub" key={uuid()}>
                {treeBars}
              </ul>
            </div>
          )
        }
      }
      if (colBarCount + barCount > maxBars) {
        activeCol++
        colBarCount = barCount
      } else {
        colBarCount += barCount
      }
      catBars.forEach((catBar) => {
        if (col[colIndex[activeCol]]) {
          col[colIndex[activeCol]].push(catBar)
        }
      })
    }
  })

  let passageBreakdowns = null
  if (name === 'Reading' || name === 'Science') {
    passageBreakdowns = (
      <PassageBreakdowns
        data={byPassageType}
      />
    )
  }

// edit
  return (
    <div className={classString}>
      <section className="page-header">
        <h3 className="page-title">{name} Report</h3>
        <h3 className="school-class-info">{headerText}</h3>
      </section>
      <ScoreChart 
        name={name}
        bySubtest={bySubtest}
      />
      <AreasToImprove
        byNode={byNode}
        bySubtest={bySubtest}
        subject={name}
        nodes={nodes}
        isGroup={isGroup}
      />
      {passageBreakdowns}
      <section className="skill-breakdowns">
        <div className="col col-1">
          {col.one}
        </div>
        <div className="col col-2">
          {col.two}
        </div>
        <div className="col col-3">
          {col.three}
        </div>
      </section>
    </div>

  )
}



/*








          <div className="skill-category">
            <div className="skill-item">
              <h6 className="title">Punctuation Conventions</h6>
              <div className="bar-graph">
                <span className="score-percent">
                  42%
                </span>
                <div className="score-graph-container">
                  <span className="score-graph" style="width: 42%;"></span>
                </div>
              </div>
            </div>
          </div>


          <div className="skill-item sub-skill">
            <h6 className="title">Apostrophes</h6>
            <div className="bar-graph">
              <span className="score-percent">
                71%
              </span>
              <div className="score-graph-container">
                <span className="score-graph" style="width: 71%;"></span>
              </div>
            </div>
          </div>

          			<div class="skill-item sub-skill">
				<h6 class="title">Sentence Structure Disturbances</h6>
				<div class="bar-graph">
					<span class="score-percent">
						57%
					</span>
					<div class="score-graph-container">
						<span class="score-graph" style="width: 57%;"></span>
					</div>
				</div>

				<ul class="sub-of-sub">
					<li>
						<span class="tree-friend"></span>
						<div class="skill-item sub-skill">
							<h6 class="title">Fragments and Fused Sentences</h6>
							<div class="bar-graph">
								<span class="score-percent">
									43%
								</span>
								<div class="score-graph-container">
									<span class="score-graph" style="width: 43%;"></span>
								</div>
							</div>
						</div>
					</li>
					<li>
						<span class="tree-friend"></span>
						<div class="skill-item sub-skill">
							<h6 class="title">Parallelism</h6>
							<div class="bar-graph">
								<span class="score-percent">
									43%
								</span>
								<div class="score-graph-container">
									<span class="score-graph" style="width: 43%;"></span>
								</div>
							</div>
						</div>
					</li>
					<li>
						<span class="tree-friend"></span>
						<div class="skill-item sub-skill">
							<h6 class="title">Participial Phrases</h6>
							<div class="bar-graph">
								<span class="score-percent">
									43%
								</span>
								<div class="score-graph-container">
									<span class="score-graph" style="width: 43%;"></span>
								</div>
							</div>
						</div>
					</li>
					<li>
						<span class="tree-friend"></span>
						<div class="skill-item sub-skill">
							<h6 class="title">Relative Pronouns</h6>
							<div class="bar-graph">
								<span class="score-percent">
									43%
								</span>
								<div class="score-graph-container">
									<span class="score-graph" style="width: 43%;"></span>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>



          <div className="skill-item sub-skill">
            <h6 className="title">Colons and Semicolons</h6>
            <div className="bar-graph">
              <span className="score-percent">
                57%
              </span>
              <div className="score-graph-container">
                <span className="score-graph" style="width: 57%;"></span>
              </div>
            </div>
          </div>

          <div className="skill-item sub-skill">
            <h6 className="title">Parenthetical Elements</h6>
            <div className="bar-graph">
              <span className="score-percent">
                43%
              </span>
              <div className="score-graph-container">
                <span className="score-graph" style="width: 43%;"></span>
              </div>
            </div>
          </div>

          <div className="skill-item sub-skill">
            <h6 className="title">Unnecessary Commas</h6>
            <div className="bar-graph">
              <span className="score-percent">
                31%
              </span>
              <div className="score-graph-container">
                <span className="score-graph" style="width: 31%;"></span>
              </div>
            </div>
          </div>




          <div className="skill-category">
            <div className="skill-item">
              <h6 className="title">Punctuation Conventions</h6>
              <div className="bar-graph">
                <span className="score-percent">
                  42%
                </span>
                <div className="score-graph-container">
                  <span className="score-graph" style="width: 42%;"></span>
                </div>
              </div>
            </div>
          </div>


          <div className="skill-item sub-skill">
            <h6 className="title">Apostrophes</h6>
            <div className="bar-graph">
              <span className="score-percent">
                71%
              </span>
              <div className="score-graph-container">
                <span className="score-graph" style="width: 71%;"></span>
              </div>
            </div>
          </div>


          <div className="skill-item sub-skill">
            <h6 className="title">Colons and Semicolons</h6>
            <div className="bar-graph">
              <span className="score-percent">
                57%
              </span>
              <div className="score-graph-container">
                <span className="score-graph" style="width: 57%;"></span>
              </div>
            </div>
          </div>

          <div className="skill-item sub-skill">
            <h6 className="title">Parenthetical Elements</h6>
            <div className="bar-graph">
              <span className="score-percent">
                43%
              </span>
              <div className="score-graph-container">
                <span className="score-graph" style="width: 43%;"></span>
              </div>
            </div>
          </div>

          <div className="skill-item sub-skill">
            <h6 className="title">Unnecessary Commas</h6>
            <div className="bar-graph">
              <span className="score-percent">
                31%
              </span>
              <div className="score-graph-container">
                <span className="score-graph" style="width: 31%;"></span>
              </div>
            </div>
          </div>

        </div>

        <div className="col col-2">
          <div className="skill-category">
            <div className="skill-item">
              <h6 className="title">Sentence Structure &amp; Formation</h6>
              <div className="bar-graph">
                <span className="score-percent">
                  42%
                </span>
                <div className="score-graph-container">
                  <span className="score-graph" style="width: 42%;"></span>
                </div>
              </div>
            </div>
          </div>


          <div className="skill-item sub-skill">
            <h6 className="title">Pronouns</h6>
            <div className="bar-graph">
              <span className="score-percent">
                71%
              </span>
              <div className="score-graph-container">
                <span className="score-graph" style="width: 71%;"></span>
              </div>
            </div>
          </div>


          <div className="skill-item sub-skill">
            <h6 className="title">Sentence Structure Disturbances</h6>
            <div className="bar-graph">
              <span className="score-percent">
                57%
              </span>
              <div className="score-graph-container">
                <span className="score-graph" style="width: 57%;"></span>
              </div>
            </div>

            <ul className="sub-of-sub">
              <li>
                <span className="tree-friend"></span>
                <div className="skill-item sub-skill">
                  <h6 className="title">Fragments and Fused Sentences</h6>
                  <div className="bar-graph">
                    <span className="score-percent">
                      43%
                    </span>
                    <div className="score-graph-container">
                      <span className="score-graph" style="width: 43%;"></span>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <span className="tree-friend"></span>
                <div className="skill-item sub-skill">
                  <h6 className="title">Parallelism</h6>
                  <div className="bar-graph">
                    <span className="score-percent">
                      43%
                    </span>
                    <div className="score-graph-container">
                      <span className="score-graph" style="width: 43%;"></span>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <span className="tree-friend"></span>
                <div className="skill-item sub-skill">
                  <h6 className="title">Participial Phrases</h6>
                  <div className="bar-graph">
                    <span className="score-percent">
                      43%
                    </span>
                    <div className="score-graph-container">
                      <span className="score-graph" style="width: 43%;"></span>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <span className="tree-friend"></span>
                <div className="skill-item sub-skill">
                  <h6 className="title">Relative Pronouns</h6>
                  <div className="bar-graph">
                    <span className="score-percent">
                      43%
                    </span>
                    <div className="score-graph-container">
                      <span className="score-graph" style="width: 43%;"></span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div className="skill-category">
            <div className="skill-item">
              <h6 className="title">Sentence Structure &amp; Formation</h6>
              <div className="bar-graph">
                <span className="score-percent">
                  42%
                </span>
                <div className="score-graph-container">
                  <span className="score-graph" style="width: 42%;"></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col col-3">
          <div className="skill-category">
            <div className="skill-item">
              <h6 className="title">Punctuation Conventions</h6>
              <div className="bar-graph">
                <span className="score-percent">
                  42%
                </span>
                <div className="score-graph-container">
                  <span className="score-graph" style="width: 42%;"></span>
                </div>
              </div>
            </div>
          </div>


          <div className="skill-item sub-skill">
            <h6 className="title">Apostrophes</h6>
            <div className="bar-graph">
              <span className="score-percent">
                71%
              </span>
              <div className="score-graph-container">
                <span className="score-graph" style="width: 71%;"></span>
              </div>
            </div>
          </div>


          <div className="skill-item sub-skill">
            <h6 className="title">Colons and Semicolons</h6>
            <div className="bar-graph">
              <span className="score-percent">
                57%
              </span>
              <div className="score-graph-container">
                <span className="score-graph" style="width: 57%;"></span>
              </div>
            </div>
          </div>

          <div className="skill-item sub-skill">
            <h6 className="title">Parenthetical Elements</h6>
            <div className="bar-graph">
              <span className="score-percent">
                43%
              </span>
              <div className="score-graph-container">
                <span className="score-graph" style="width: 43%;"></span>
              </div>
            </div>
          </div>

          <div className="skill-item sub-skill">
            <h6 className="title">Unnecessary Commas</h6>
            <div className="bar-graph">
              <span className="score-percent">
                31%
              </span>
              <div className="score-graph-container">
                <span className="score-graph" style="width: 31%;"></span>
              </div>
            </div>
          </div>



        </div>

      </section>

    </div>

    */


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/SkillBreakdownReport.js